import { VendorTransferDetailPage } from "@/features/vendor-app/pages/VendorTransferDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/transfer/$type/$id")({
	component: VendorTransferDetailPage,
});
